module.exports = __webpack_public_path__ + "static/media/rams-mens-tshirt.7136e613.png";